import {
  Box,
  Card,
  Image,
  Stack,
  Text,
  Title,
} from '@mantine/core'
import React, { ReactNode } from 'react'


interface AuthShellProps {
  title: string
  subtitle?: string | React.ReactNode
  children: ReactNode
}

export const AuthShell = ({
  title,
  subtitle,
  children,
}: AuthShellProps) => (
  <Box className={'background'}>
    <Card
      shadow={'xl'}
      radius={'md'}
      p={{
        base: 'xl',
        xs: 40,
      }}
      w={'calc(100% - 32px)'}
      maw={500}
      m={'auto'}
      withBorder
    >
      <Stack
        align={'stretch'}
        gap={'lg'}
      >
        <Image
          src={'/logo.png'}
          alt={'Smartflow Logo'}
          w={200}
          mx={'auto'}
        />
        <Stack gap={4}>
          <Title
            order={2}
            ta={'center'}
            c={'gray.9'}
          >
            {title}
          </Title>
          {subtitle && (
            <Text
              ta={'center'}
              c={'gray.6'}
              size={'sm'}
            >
              {subtitle}
            </Text>
          )}
        </Stack>
        {children}
      </Stack>
    </Card>
  </Box>
)
